import React from 'react';
import { useRouter } from 'next/router';

import { Loader } from 'components/ui';
import { APP_ROUTES } from 'constants/routes';
import { getRefreshToken } from 'helpers/AuthenticationHelpers';
import { encodeRedirectState } from 'helpers/UrlHelpers';
import { useIsAuthenticated } from 'hooks/useIsAuthenticated';
import AuthenticationService from 'services/AuthenticationService';

const withAuth = (WrappedComponent: any) => {
  return (props: any) => {
    const router = useRouter();
    const { accessToken } = useIsAuthenticated();
    const [verified, setVerified] = React.useState(false);

    React.useEffect(() => {
      const checkAuthStatus = async () => {
        if (accessToken) {
          setVerified(true);
        } else {
          const refreshToken = getRefreshToken();
          if (!refreshToken) {
            router.push({ pathname: APP_ROUTES.LOGIN, query: { state: encodeRedirectState(window.location.pathname) } });
          } else {
            try {
              const response = await AuthenticationService.verifyAccessToken();
              const { data } = response;
              if (data) {
                setVerified(true);
              }
            } catch (err) {
              // handle error
            }
          }
        }
      };
      checkAuthStatus();
    }, []);

    if (verified) {
      return <WrappedComponent {...props} />;
    }
    return (
      <Loader
        size={24}
        lineWeight={2}
        fullscreen
      />
    );

  };
};

export default withAuth;
